import { apiUrlOriginacao } from "@settings";

import { getBaseAxiosInstance } from "./base";

const BASE_URL = apiUrlOriginacao;

export default getBaseAxiosInstance(BASE_URL);
